import React from "react";

interface ConfirmLogoProps {
  width?: any,
  height?: any
}

const ConfirmLogo: React.FC<ConfirmLogoProps> = ({width = 20, height = 20}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 558.098 558.096">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_4529" data-name="Rectangle 4529" width="531.034" height="531.031"
                transform="translate(0 0)" fill="#f5f5f5" stroke="#707070" strokeWidth="1"/>
        </clipPath>
      </defs>
      <g id="Mask_Group_471" data-name="Mask Group 471" transform="translate(27.792) rotate(3)">
        <g id="tick_2_" data-name="tick (2)" transform="translate(4.489 84.759)">
          <g id="Group_16570" data-name="Group 16570" transform="translate(0 0)">
            <g id="Group_16569" data-name="Group 16569">
              <path id="Path_56843" data-name="Path 56843"
                    d="M500.476,12.43a39.838,39.838,0,0,0-56.334-1.488l-254.4,241.266L68.395,127.622a39.848,39.848,0,0,0-57.093,55.6L160.077,335.973a39.863,39.863,0,0,0,55.978,1.116L498.991,68.766A39.843,39.843,0,0,0,500.476,12.43Z"
                    fill="green"/>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default ConfirmLogo;